<template>
    <button
        v-tippy="t('editorToggleBlockqoute')"
        :class="[
            buttonState(editor.can().toggleBlockquote(), editor.isActive('blockquote')),
            'flex-none rounded p-1 text-sm',
        ]"
        :disabled="!editor.can().toggleBlockquote()"
        @click="editor.chain().focus().toggleBlockquote().run()"
    >
        <MdiCommentQuote class="h-6 w-6" />
    </button>
</template>
<script setup>
    import { buttonState } from '../../composables/useWYSIWYGEditorUtils';
    import MdiCommentQuote from 'materialdesignicons-vue3/icons/MdiCommentQuote.js';

    defineExpose({
        name: 'FormatBlockquoteButton',
    });

    const props = defineProps({
        editor: {
            type: Object,
            required: true,
        },
    });

    const editor = props.editor;
</script>
